import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export default function Navbar() {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/cv', label: 'CV' },
    { path: '/courses', label: 'Dersler' },
    { path: '/projects', label: 'Projeler' },
    { path: '/papers', label: 'Yayınlar' },
    {
      path: '#',
      label: 'Daha Fazla',
      submenu: [
        { path: '/lab', label: 'Laboratuvar' },
        { path: '/statistics', label: 'İstatistikler' },
        { path: '/links', label: 'Bağlantılar' },
        { path: '/announcements', label: 'Duyurular' }
      ]
    },
    { path: '/contact', label: 'İletişim' }
  ];

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link to="/" className="flex-shrink-0">
              <h1 className="text-2xl md:text-3xl font-serif text-navy font-bold hover:text-navy-light transition-colors">
                Memduh Köse
              </h1>
            </Link>
          </motion.div>

          {/* Desktop Menu */}
          <ul className="hidden md:flex gap-4 lg:gap-6 text-base lg:text-lg font-sans items-center">
            {navItems.map((item, index) => (
              <motion.li 
                key={item.path} 
                className="relative group"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * index, duration: 0.3 }}
              >
                {item.submenu ? (
                  <>
                    <button
                      className={`${
                        item.submenu.some(sub => isActive(sub.path))
                          ? 'text-navy font-semibold'
                          : 'text-gray-600 hover:text-navy'
                      } transition-colors duration-200 flex items-center gap-1`}
                    >
                      {item.label}
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {/* Dropdown Animation */}
                    <div className="absolute left-0 mt-2 w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform origin-top-left group-hover:translate-y-0 translate-y-2 z-50">
                      <div className="bg-white rounded-lg shadow-lg border border-gray-100 overflow-hidden">
                        {item.submenu.map((subItem) => (
                          <Link
                            key={subItem.path}
                            to={subItem.path}
                            className={`block px-4 py-2 ${
                              isActive(subItem.path)
                                ? 'bg-navy text-white'
                                : 'text-gray-700 hover:bg-gray-50'
                            } transition-colors`}
                          >
                            {subItem.label}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className="relative"
                  >
                    <span className={`${isActive(item.path) ? 'text-navy font-semibold' : 'text-gray-600 hover:text-navy'} transition-colors duration-200`}>
                        {item.label}
                    </span>
                    {isActive(item.path) && (
                        <motion.div 
                            layoutId="underline"
                            className="absolute left-0 right-0 h-0.5 bg-navy bottom-[-4px]"
                        />
                    )}
                  </Link>
                )}
              </motion.li>
            ))}
          </ul>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-navy focus:outline-none"
            onClick={() => {
              const menu = document.getElementById('mobile-menu');
              menu?.classList.toggle('hidden');
            }}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu with AnimatePresence could be added here, but sticking to your structure simply */}
        <div id="mobile-menu" className="hidden md:hidden pb-4 transition-all duration-300 ease-in-out">
             {/* ... Mevcut mobil menü kodların aynı kalabilir veya animasyon eklenebilir ... */}
             <ul className="flex flex-col gap-3">
                {navItems.map((item) => (
                    // ... (Mevcut kodların aynısı)
                    <li key={item.path}>
                        {/* İçeriği koru */}
                         <Link to={item.path} className="block py-2 text-gray-600 hover:text-navy">{item.label}</Link>
                    </li>
                ))}
             </ul>
        </div>
      </div>
    </nav>
  );
}